import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let ProspectorAddOnDialogComponent = {
    selector: "vcProspectorAddOnDialog",
    templateUrl:
        "/angular/components/prospector/prospector-add-on-dialog.component.html",
    bindings: {},
    controller: class ProspectorAddOnDialogController {
        private dialog: DialogUtils;
        private $window: any;
        public currency: string;

        constructor($window: any, DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
            this.$window = $window;
        }

        close(): void {
            this.dialog.cancel();
        }

        confirm(): void {
            this.$window.Intercom(
                "showNewMessage",
                "Hello, I would like to purchase the Prospector add-on please"
            );
            this.dialog.cancel();
        }
    },
};

angular
    .module("dashboard")
    .component(
        ProspectorAddOnDialogComponent.selector,
        ProspectorAddOnDialogComponent
    );
